var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "backer-center-layout",
    {
      attrs: {
        size: "narrow",
        title: _vm.Resources.BackerCenter.SectionProjectsHeader,
        "current-view": "projects",
      },
    },
    [
      _c("filter-view", {
        attrs: {
          filters: _vm.projectsFilters,
          "hidden-filter-keys": ["projectInteractionTypes"],
          "hidden-selected-keys": ["projectInteractionTypes"],
          "filter-list-title": _vm.Resources.Search.SearchFiltersHeader,
          "sort-list-title": _vm.Resources.Search.SearchProjectSortTitle,
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function ({ filters, onFilterChange }) {
              return [
                _c("backer-center-projects-tabs", {
                  staticClass: "_mb-4",
                  attrs: {
                    "current-search-type":
                      filters.searchParams.value.projectInteractionTypes,
                  },
                  on: {
                    "tab-selected": (type) =>
                      onFilterChange("projectInteractionTypes", type),
                  },
                }),
              ]
            },
          },
          {
            key: "default",
            fn: function ({
              isProcessing,
              canLoadMore,
              loadMore,
              isLoadingMore,
            }) {
              return [
                isProcessing
                  ? _c(
                      "div",
                      {
                        class: _vm.cardListWrapperClass,
                        attrs: {
                          "data-qa": "backer-center-view-projects:Skeleton",
                        },
                      },
                      _vm._l(3, function (placeholder) {
                        return _c(
                          "div",
                          { key: placeholder },
                          [_c("skeleton-card", { staticClass: "_h-full" })],
                          1
                        )
                      }),
                      0
                    )
                  : [
                      _vm.hasProjects
                        ? [
                            _c(
                              "div",
                              { class: _vm.cardListWrapperClass },
                              _vm._l(_vm.mainProjectItems, function (item) {
                                return _c(
                                  "div",
                                  {
                                    key: item.props.projectID,
                                    attrs: {
                                      "data-qa": `search-result-project:${item.props.projectID}`,
                                    },
                                  },
                                  [
                                    _c(
                                      item.component,
                                      _vm._b(
                                        { tag: "component" },
                                        "component",
                                        item.props,
                                        false
                                      )
                                    ),
                                  ],
                                  1
                                )
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _c(
                              "backer-center-project-recommendations-section",
                              {
                                staticClass: "_my-6",
                                attrs: { "data-qa": "Recommendations" },
                              }
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { class: _vm.cardListWrapperClass },
                              [
                                _vm._l(
                                  _vm.remainingProjectItems,
                                  function (item) {
                                    return _c(
                                      "div",
                                      {
                                        key: item.props.projectID,
                                        attrs: {
                                          "data-qa": `search-result-project:${item.props.projectID}`,
                                        },
                                      },
                                      [
                                        _c(
                                          item.component,
                                          _vm._b(
                                            { tag: "component" },
                                            "component",
                                            item.props,
                                            false
                                          )
                                        ),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                _vm._v(" "),
                                isLoadingMore
                                  ? _vm._l(3, function (placeholder) {
                                      return _c(
                                        "div",
                                        { key: placeholder },
                                        [
                                          _c("skeleton-card", {
                                            staticClass: "_h-full",
                                          }),
                                        ],
                                        1
                                      )
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                canLoadMore
                                  ? _c("load-more-trigger", {
                                      on: { "load-more": loadMore },
                                    })
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ]
                        : [
                            _c(
                              "box",
                              { staticClass: "_mt-2" },
                              [
                                _c(
                                  "empty-state",
                                  {
                                    attrs: {
                                      title:
                                        _vm.Resources.Search
                                          .SearchProjectsResultsEmptyStateTitle,
                                      description:
                                        _vm.Resources.Search
                                          .SearchProjectsResultsEmptyStateParagraph,
                                      "data-qa":
                                        "backer-center-view-projects:EmptyState",
                                    },
                                  },
                                  [
                                    _c(
                                      "base-button",
                                      {
                                        staticClass: "_mt-3",
                                        attrs: {
                                          tag: "a",
                                          href: _vm.searchUrl,
                                          icon: "search",
                                          theme: "accent",
                                          "data-qa":
                                            "backer-center-view-projects:ExploreProjects",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.Resources.BackerCenter
                                                .UpdatesFeedEmptyStateButtonLabel
                                            ) +
                                            "\n                            "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "backer-center-project-recommendations-section",
                              {
                                staticClass: "_mt-6",
                                attrs: { "data-qa": "Recommendations" },
                              }
                            ),
                          ],
                    ],
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }